module.exports = __webpack_public_path__ + "img/demigods_1920.ac2a3f44.png";